"use client";
import { jsx as d, jsxs as v } from "react/jsx-runtime";
import { forwardRef as x, createElement as o } from "react";
import c from "./TableCell.js";
import m from "./TableRow.js";
import I from "./useTable.js";
import { css as l } from "@emotion/react";
import i from "@emotion/styled";
import { COLORS as T } from "../../tokens/colors/Colors.js";
import { SPACINGS as R } from "../../tokens/spacings/Spacings.js";
const k = x(
  ({
    feBody: r,
    feCaption: p,
    feCompact: y = !1,
    feFoot: b,
    feHead: u,
    feInteractive: $ = !1,
    feScrollable: f,
    ...g
  }, w) => {
    const { sortedBody: S, sortedHead: h, sorting: n } = I(r, u);
    return /* @__PURE__ */ d(j, { ...g, "data-comp": "table", feScrollable: f, ref: w, tabIndex: 0, children: /* @__PURE__ */ v(C, { children: [
      p && /* @__PURE__ */ d(H, { children: p }),
      h && /* @__PURE__ */ d(N, { feScrollable: f, children: h.map((t, s) => /* @__PURE__ */ o(m, { ...t, key: `row-${s}`, interactive: !1, type: "head" }, t.cells.map((e, a) => /* @__PURE__ */ o(
        c,
        {
          ...e,
          as: e.as ?? "th",
          compact: !0,
          index: a,
          key: a,
          sorting: n
        },
        e.children
      )))) }),
      b && /* @__PURE__ */ d(O, { children: b.map((t, s) => /* @__PURE__ */ o(m, { ...t, key: `row-${s}`, interactive: !1, type: "foot" }, t.cells.map((e, a) => /* @__PURE__ */ o(
        c,
        {
          ...e,
          as: e.as ?? "td",
          compact: y,
          index: a,
          key: a,
          sorting: n
        },
        e.children
      )))) }),
      /* @__PURE__ */ d("tbody", { children: S.map((t, s) => /* @__PURE__ */ o(m, { ...t, key: `row-${s}`, interactive: $, type: "body" }, t.cells.map((e, a) => /* @__PURE__ */ o(
        c,
        {
          ...e,
          as: e.as ?? "td",
          compact: y,
          index: a,
          key: a,
          sorting: n
        },
        e.children
      )))) })
    ] }) });
  }
);
k.displayName = "Table";
const F = k, j = i.div(
  ({ feScrollable: r }) => l`
		overflow-x: auto;

		${r && l`
			height: 100%;
			overflow-y: auto;
		`}
	`
), C = i.table`
	border-collapse: collapse;
	white-space: nowrap;
	width: 100%;
`, H = i.caption`
	margin: 0 0 ${R.md};
	text-align: left;
`, N = i.thead(
  ({ feScrollable: r }) => l`
		background: ${T.gray100};

		${r && l`
			position: sticky;
			top: 0;
		`}
	`
), O = i.tfoot`
	background: ${T.gray100};
`;
export {
  F as default
};
